import {refresh_token} from "./api/port";

export default {
  install(Vue) {

    //根据sessionKey获取用户信息 全局函数
    Vue.prototype.getUserInfo = function (userinfosessionKey, redirect, callback){
      const _this = this;
      redirect = redirect ? decodeURIComponent(redirect) : undefined;
      console.log(redirect)

      // console.log(_this.GLOBAL.pageApiUrl + '/user/checkUserInfo')
      // console.log(userinfosessionKey)

      _this.axios.post(_this.$store.state.api.common + '/index.php/login/get_userinfo_by_token', _this.qs.stringify({
        token: userinfosessionKey
      })).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              _this.$toast.fail('接口异常');
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){
            const fetch_data = res.data.data;
            //console.log(fetch_data);

            let user_data = {


              sessionkey: fetch_data.token,

              roletypecode: fetch_data.type,
              orgname: fetch_data.name,

              id: fetch_data.id,
              username: fetch_data.username,

              nickname: fetch_data.nickname ? fetch_data.nickname : '无昵称',
              name: fetch_data.realname,
              avatar: fetch_data.user_img,
              phone: fetch_data.username,
              //email: "",
              //birthday: "1991-11-04",
              //sex: "2",
              // address: {
              //   province_id: 140000,
              //   city_id: 140100,
              //   address: "昆山",
              // },
              service_shopno: fetch_data.service_shopno,
              role: fetch_data.usertype,

              sbucode: fetch_data.sbuCode,
              dealercode: fetch_data.dealerCode,
              shopno: fetch_data.shopno,

              orgcode: fetch_data.code,

            }

            //本地存储
            localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session
            //sessionStorage.setItem('user_','#/IndexA');

            //读取
            //console.log( localStorage.getItem('user_data') );
            //console.log( JSON.parse(localStorage.getItem('user_data')) );

            //_this.$router.replace({ path: '/'});
            //location.replace('/');

            callback && callback();
            if(fetch_data.type == 'sbu'){
              _this.$dialog.alert({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '提示',
                message: '当前角色无法使用！',
                showCancelButton: false,
                confirmButtonText: '返回O+O',
              }).then(() => {
                if( _this.$store.state.browser.giantopoapp){
                  if( _this.$store.state.browser.ios ){
                    window.webkit.messageHandlers.back.postMessage('');
                  }else{
                    android.back();
                  }
                }else{
                  location.replace(_this.$store.state.externalurl.opo);
                }
              }).catch(() => {
              });
              return false;
            }
            if( redirect ){
              const isSkip = redirect.indexOf('isToDo=1') > -1;
              if( user_data.roletypecode == 'storeManager' ){
                redirect = window.location.origin + '/#/' + (isSkip ? '?isToDo=1' : '');
              }else if (user_data.roletypecode == 'master' || user_data.roletypecode == 'dealer' ){
                redirect = window.location.origin + '/#/order/head_and_class' + (isSkip ? '?isToDo=1' : '');
              }
              location.replace(redirect);

              // if( redirect != './' ){
              //   location.reload();
              // }
              return false;
            }
            _this.$router.replace({ path: '/index'});

          } else if( res.data.status == 0 ){
            //_this.$toast(res.data.msg);
            _this.$dialog.alert({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '登录失效',
              message: res.data.msg,
              showCancelButton: false,
              confirmButtonText: '登录',
            }).then(() => {
              _this.$router.replace({ path: '/login', query: { redirect: redirect }});
              //location.replace(_this.$store.state.externalurl.opo);
            }).catch(() => {
            });

          } else {
            //_this.$toast('出现了一些问题');
            _this.$dialog.alert({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '登录失效',
              message: res.data.msg ? res.data.msg : '出现了一些问题',
              showCancelButton: false,
              confirmButtonText: '登录',
            }).then(() => {
              //location.replace(_this.$store.state.externalurl.opo);
              _this.$router.replace({ path: '/login', query: { redirect: redirect }});
            }).catch(() => {
            });
          }

        } else {
          //_this.$toast('请求失败');
          _this.$dialog.alert({
            closeOnPopstate: true,//页面回退时自动关闭
            title: '登录失败',
            message: '缺少关键信息',
            showCancelButton: false,
            confirmButtonText: '登录',
          }).then(() => {
            //location.replace(_this.$store.state.externalurl.opo);
            _this.$router.replace({ path: '/login', query: { redirect: redirect }});
          }).catch(() => {
          });
        }

      }).catch(function (error) {
        //_this.$toast(error);
        console.log(error);
        _this.$dialog.alert({
          closeOnPopstate: true,//页面回退时自动关闭
          title: '登录失败',
          message: '缺少关键信息',
          showCancelButton: false,
          confirmButtonText: '登录',
        }).then(() => {
          //location.replace(_this.$store.state.externalurl.opo);
          _this.$router.replace({ path: '/login', query: { redirect: redirect }});
        }).catch(() => {
        });
      });
    }

    window.refreshToken = (res) => {
      _this.refreshToken(res);
    };

    Vue.prototype.refreshToken = function (token){
      let user_data = JSON.parse(localStorage.getItem('giant_userdata'));

      user_data.sessionkey = token;

      //本地存储
      localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session

      _this.$store.commit('updateLoginUser', user_data);
    }

    //刷新sessionKey（token） 全局函数
    Vue.prototype.refreshToken = function (callback, redirect){
      const _this = this;

      //如果在App环境中，调用App的刷新Token方法
      if( _this.$store.state.browser.giantopoapp ){

        let _token = '';

        if( _this.$store.state.browser.ios ){
          // _token = window.webkit.messageHandlers.opoOC.getToken();
          window.webkit.messageHandlers.getToken.postMessage('')
        } else {
          const readPermission = android.getPermission("read")
          if(!readPermission)return
          _token = android.getToken();

          let user_data = JSON.parse(localStorage.getItem('giant_userdata'));

          user_data.sessionkey = _token;

          //本地存储
          localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session

          _this.$store.commit('updateLoginUser', user_data);
        }

      }else{
        // _this.$router.replace({ path: '/login', query: { redirect: redirect }});
      }
      // return false;
      // console.log(_this.GLOBAL.pageApiUrl + '/user/checkUserInfo')
      // console.log(userinfosessionKey)
      //console.log(callback)
      //console.log(redirect+':ref')

      refresh_token().then(function(res){
          if( res.status == 1 ){
            const fetch_data = res.data;
            let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata'));
            loginuser_data.sessionkey = fetch_data;
            localStorage.setItem('giant_userdata', JSON.stringify(loginuser_data));
            _this.$store.commit('updateLoginUser', loginuser_data);
            if( typeof callback == "function" ){
              callback();
            }
          } else if( res.status == 0 ){
            //_this.$toast(res.data.msg);
            _this.$dialog.alert({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '登录信息失效',
              message: res.msg ? res.msg : '出现了一些问题',
              showCancelButton: false,
              confirmButtonText: '登录',
            }).then(() => {
              location.replace(_this.$store.state.externalurl.opo);
              // _this.$router.replace({ path: '/login', query: {redirect: redirect}});
            }).catch(() => {
            });
          } else {
            _this.$dialog.alert({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '登录信息失效',
              message: res.msg ? res.msg : '出现了一些问题',
              showCancelButton: false,
              confirmButtonText: '登录',
            }).then(() => {
              location.replace(_this.$store.state.externalurl.opo);
              // _this.$router.replace({ path: '/login', query: {return_href: redirect}});
            }).catch(() => {
            });
          }
      }).catch(function (error) {
        _this.$toast(error);
      });
    }

    // 中国标准时间转化为年月日时分字符串
    Vue.prototype.getStandardTime = function (time) {
      let date = new Date(time);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      let D = (date.getDate() < 10 ? '0'+date.getDate() + ' ' : date.getDate()) + ' ';
      let h = date.getHours() < 10 ? '0'+date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes();
      return Y+M+D+h+m;
    }
    // 过滤表情包
    Vue.prototype.formateEmoji = function (value,type) {
      if (type == 'replace') {
        value = value.replace(/[：: ]/g, ''); // 替换中英文冒号 空格
      }
      value = value.replace(
        /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g,
        '')
      // 过滤零宽度字符和其他不可见字符  -- 会导致富文本 ios 14 pro 15pro 无法连续输入文字
      return value
    }
    // 过滤字符串只能输入数字
    Vue.prototype.formateNumber = function (value) {
      value = value.replace(/\D/g, '')
      // 过滤零宽度字符和其他不可见字符  -- 会导致富文本 ios 14 pro 15pro 无法连续输入文字
      return value
    }
    //503倒计时刷新
    Vue.prototype.countDown503 = function (time){
      let tips503 = '当前访问人数较多，请稍后再试'
      let second;
      if(time){
        second = time;
      } else {
        second = 5;
      }

      const toast = _this.$toast.loading({
        duration: 0, // 持续展示 toast
        overlay:true,
        forbidClick: true,
        closeOnClickOverlay: false,
        message: tips503 +'\n'+second+'S',
      });
      const timer = setInterval(() => {
        second--;
        if (second) {
          toast.message = tips503 + '\n' +`${second}S`;
        } else {
          clearInterval(timer);
          // 手动清除 Toast
          toast.clear();

          _this.$dialog.confirm({
            title: '请点击刷新',
            message: '',
            confirmButtonText: '刷新重试',
            cancelButtonText: '',
            showCancelButton: false
          }).then(() => {
            location.reload(true);
          }).catch(() => {

          });
        }
      }, 1000);
    }
  }
}







// WEBPACK FOOTER //
// ./src/site.js